/**
 * Fatura ekranlarinda ortak donem secici — Giden ve Gelen Faturalar ayni
 * duzeni kullanir: ustte yil, yaninda 12 ay, sonda "Son 6 Ay".
 */
import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { iv } from './invoiceTheme';

export const currentMonth = () =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Istanbul' }).slice(0, 7);

/** Arsivdeki ilk fatura 27.07.2023; daha eski yil secmenin anlami yok. */
const ARSIV_BASLANGIC_YILI = 2023;
const ayEtiketi = (ay) => String(ay || '').split('-').reverse().join('.');
const AY_KISA = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

/** Bir yilin 12 ayi ('YYYY-MM' listesi). "Tumu" dugmesi bunu kullanir. */
export const yilAylari = (yil) =>
  Array.from({ length: 12 }, (_, i) => `${yil}-${String(i + 1).padStart(2, '0')}`);

/** Secili ay dahil geriye dogru n ay ('YYYY-MM' listesi, eskiden yeniye). */
export const sonAylar = (bitisAy, adet = 6) => {
  const [y, a] = String(bitisAy || '').split('-').map(Number);
  if (!y || !a) return [];
  const liste = [];
  for (let i = adet - 1; i >= 0; i -= 1) {
    const d = new Date(Date.UTC(y, a - 1 - i, 1));
    liste.push(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`);
  }
  return liste;
};

/**
 * Donem secici — yil sekmeleri + ay dugmeleri (Kolaysoft portalindaki duzen).
 * Tek satirlik "tarih kutusu" yerine: hangi ayda oldugun bir bakista gorunuyor
 * ve ay degistirmek tek tiklama. Dugmeler icerigi kadar genis, yer israfi yok.
 */
const InvoicePeriodSelector = ({ month, son6, tumYil, disabled, onMonth, onSon6, onTumYil }) => {
  const bugun = currentMonth();
  const buYil = Number(bugun.slice(0, 4));
  const buAy = Number(bugun.slice(5, 7));
  const yil = Number(String(month).slice(0, 4)) || buYil;
  const ay = Number(String(month).slice(5, 7)) || buAy;
  const yillar = [];
  for (let y = buYil; y >= ARSIV_BASLANGIC_YILI; y -= 1) yillar.push(y);

  const yilSec = (y) => {
    // Yil degisince ayi koru; gelecekteki bir aya dusuyorsa son gecerli aya cek.
    // "Tumu" acikken yil degistirmek o yilin tamamini gosterir (mod korunur).
    const enBuyukAy = y === buYil ? buAy : 12;
    onMonth(`${y}-${String(Math.min(ay, enBuyukAy)).padStart(2, '0')}`, { modKoru: true });
  };

  const dugme = (secili, enAz = 0) => ({
    minWidth: enAz,
    px: 1.6,
    py: 0.55,
    minHeight: 34,
    fontSize: 14,
    fontWeight: 800,
    lineHeight: 1.5,
    textTransform: 'none',
    borderRadius: 1.2,
    color: secili ? '#fff' : iv.text,
    bgcolor: secili ? iv.primary : '#fff',
    border: `1px solid ${secili ? iv.primary : iv.border}`,
    '&:hover': { bgcolor: secili ? iv.primary : iv.primarySoft, borderColor: iv.primary },
    '&.Mui-disabled': { color: iv.textMuted, bgcolor: '#f8fafc', borderColor: iv.border }
  });

  return (
    <Stack
      direction="row"
      spacing={1.2}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      sx={{ opacity: disabled ? 0.45 : 1, pointerEvents: disabled ? 'none' : 'auto' }}
    >
      <Stack direction="row" spacing={0.6} flexWrap="wrap" useFlexGap>
        {yillar.map((y) => (
          <Button key={y} size="small" onClick={() => yilSec(y)} sx={dugme(y === yil && !son6, 58)}>
            {y}
          </Button>
        ))}
      </Stack>
      <Box sx={{ width: '1px', height: 26, bgcolor: iv.border }} />
      <Stack direction="row" spacing={0.6} flexWrap="wrap" useFlexGap>
        {AY_KISA.map((ad, i) => {
          const no = i + 1;
          const gelecek = yil === buYil && no > buAy;
          return (
            <Button
              key={ad}
              size="small"
              disabled={gelecek}
              onClick={() => onMonth(`${yil}-${String(no).padStart(2, '0')}`)}
              sx={dugme(!son6 && !tumYil && no === ay, 48)}
            >
              {ad}
            </Button>
          );
        })}
      </Stack>
      <Button size="small" onClick={onSon6} sx={{ ...dugme(son6), px: 1.8 }}>
        Son 6 Ay
      </Button>
      {onTumYil ? (
        <Button size="small" onClick={onTumYil} sx={{ ...dugme(tumYil), px: 1.8 }}>
          Tümü
        </Button>
      ) : null}
    </Stack>
  );
};

export { ayEtiketi, AY_KISA, ARSIV_BASLANGIC_YILI };
export default InvoicePeriodSelector;
